"use strict";

var _VEMsgDefinations = require("../../../message/messageTypeDefinitions/ve/VEMsgDefinations");
var _videoEngines = require("../../functions/videoEngines");
var _StandaloneMsgHandler = require("../../eventbus/StandaloneMsgHandler");
(0, _StandaloneMsgHandler.registerStandaloneMsgHandler)(_VEMsgDefinations.REQUEST_LIST_VIDEO_ENGINES, function (payload) {
  (0, _StandaloneMsgHandler.respondStandaloneRequest)(_VEMsgDefinations.RESPONSE_LIST_VIDEO_ENGINES, (0, _videoEngines.getStandadloneVEs)());
});